module.exports = __webpack_public_path__ + "img/ico_2.d0fa666c.png";